import { render, staticRenderFns } from "./PelleUpgradePanel.vue?vue&type=template&id=44107326&scoped=true"
import script from "./PelleUpgradePanel.vue?vue&type=script&lang=js"
export * from "./PelleUpgradePanel.vue?vue&type=script&lang=js"
import style0 from "./PelleUpgradePanel.vue?vue&type=style&index=0&id=44107326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44107326",
  null
  
)

export default component.exports